<template>
    <div class="content">
        <!-- 左边 -->
        <div class="left">
            <!-- 项目信息 -->
            <div class="project">
                <manureLeft1 />
            </div>
            <!-- 气象土壤气息 -->
            <div class="soil">
                <manureLeft2 />
            </div>
            <!-- 温室气象信息 -->
            <div class="wenshi">
                <manureLeft3 />
            </div>
        </div>
        <!-- 中间 -->
        <div class="center">
            <div class="big" v-if="videoList && videoList[0]">
                <div class="img" @click="videoClick(videoList[0])">
                    <img :src="videoList[0].coverPicture" alt="">
                </div>
                <div class="tip">
                    <p>
                        <span>{{videoList[0].name}}；</span>
                        <span>{{videoList[0].name}}；</span>
                        <span>设备类型{{videoList[0].deviceSerial}}；</span>
                        <span>设备状态正常</span>
                    </p>
                </div>
            </div>
            <div class="small" v-if="videoList && videoList.length > 0">
                <div class="small_img" v-for="(item,index) in videoList" :key="index" @click="videoClick(item)">
                    <div><img v-if="item.coverPicture" :src="item.coverPicture" alt=""></div>
                    <p>设备名称：{{ item.name || ""}}</p>
                    <p>设备状态：在线</p>
                    <p>设备位置：{{ item.name || ""}}</p>
                </div>
                <!-- <div class="more" @click="toVideoList">
                    <i class="el-icon-d-arrow-right"></i>
                </div> -->
            </div>
        </div>
        <!-- 右边 -->
        <div class="right">
            <!-- 不同生长期作物数据 -->
            <div class="crop">
                <manureRight1 />
            </div>
            <!-- 气象数据趋势 -->
            <div class="weather">
                <manureRight2 />
            </div>
            <!-- 土壤数据趋势 -->
            <div class="soliData">
                <manureRight3 />
            </div>
        </div>

        <!-- 视屏播放弹窗 -->
        <videoPlay ref="liveVideoDetail" />
        
    </div>
</template>

<script>
import { getQX_listMonitoring } from '../api/api'
import manureLeft1 from "../components/echart/manureLeft1.vue"
import manureLeft2 from "../components/echart/manureLeft2.vue"
import manureLeft3 from "../components/echart/manureLeft3.vue"
import manureRight1 from "../components/echart/manureRight1.vue"
import manureRight2 from "../components/echart/manureRight2.vue"
import manureRight3 from "../components/echart/manureRight3.vue"
import videoPlay from "../components/videoPlay.vue"
export default {
    components: {
        manureLeft1,
        manureLeft2,
        manureLeft3,
        manureRight1,
        manureRight2,
        manureRight3,
        videoPlay
    },
    data(){
        return{
            // headUrl:"https://cewud-agrinet.qixiuu.com",
            headUrl:"https://web.cewud-agrinet.com",
            bigVideoData:{},
            videoList:[],
            dialogVisible:false,
            projectId:"",
        }
    },
    created(){
        this.projectId = JSON.parse(localStorage.getItem("projectId"))
        if(this.projectId ){
            this.getVideoList(this.projectId)
        }
    },
    mounted(){
        
        let _this = this
        window.addEventListener('setItemEvent', function(e) {
            const newdata = JSON.parse(e.newValue)
            console.log('值改变了',newdata)
            _this.getVideoList(newdata)
        })
        
    },
    methods:{
        // 获取监控视屏信息
        async getVideoList(projectId){
            let res = await getQX_listMonitoring({
                projectId,
            })
            console.log(res,"监控列表");
            if(res.code == 200 && res.data.length > 0){
                this.videoList = res.data
                this.bigVideoPic = this.headUrl + res.data[0].coverPicture

                this.videoList.forEach(item => {
                    item.coverPicture =  this.headUrl + item.coverPicture
                })
                console.log(this.videoList,"视屏列表");
            }else{
                this.videoList = []
            }
        },
        
        // 跳转视频列表
        toVideoList(){
        //   this.$router.push({
        //     path:'/main/videoList',
        //   })
        },

        // 视频点击
        videoClick(item) {
            this.$refs.liveVideoDetail.title = item.name;
            this.$refs.liveVideoDetail.url = item.videoAddress;
            this.$refs.liveVideoDetail.dialogShow = true;
        },
    }
}
</script>

<style lang="scss" scoped>
.content{
    position: relative;
    width: 100%;
    height: 100%;
    background: url("../assets/addressbg.png") no-repeat;
    background-size: 100% 100%;
    color: #fff;
    padding: 35px 23px 44px;
    display: flex;
    .left{
        margin-right: 30px;
        .project{
            margin-bottom: 20px;
        }
        .soil{
            margin-bottom: 20px;
        }
    }
    .center{
        margin-right: 30px;
        .big{
            position: relative;
            margin-bottom: 46px;
            .img{
                img{
                    width: 745px;
                    height: 427px;
                }
            }
            .tip{
                position: absolute;
                top: 0;
                width: 100%;
                padding: 21px 20px;
                font-size: 20px;
                font-family: SourceHanSansSC-regular;
                background: rgba($color: #000000, $alpha: 0.7);
                border-radius: 15px;
            }
        }
        .small{
            margin-top: 20px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            height: 400px;
            overflow-y: auto;
            .small_img{
                margin-right: 20px;
                img{
                    width: 205px;
                    height: 122px;
                }
                p{
                    line-height: 26px;
                    font-size: 18px;
                    font-family: SourceHanSansSC-regular;
                    margin-bottom: 10px;
                }
            }
            .more{
                cursor: pointer;
                margin-left: 30px;
                i{
                    font-size: 24px;
                }
            }
        }
    }
    .right{
        .crop{
            margin-bottom: 13px;
        }
        .weather{
            margin-bottom: 13px;
        }
    }

}
</style>